<template>
    <div>
        <b-modal id="addNewWLRecord" size="lg" class="modal has-overflow">
          <div class="e-loader-back" v-if="loading">
            <div class="e-loader-content">
              <div class="ball-clip-rotate-multiple">
                <div></div>
                <div></div>
              </div>
              <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
            </div>
          </div>
          <template v-slot:modal-header>
          <div class="w-100">
            <h4 class="e-mtavr-17 e-bold modal-title">ახალი ჩანაწერი</h4>
          </div>
          </template>
          <b-form>
              <div class="row no-gutters row-bordered">
            <!-- Login -->
            <div class="col-md-12">
              <div class="px-4 px-sm-5 pt-4 pb-5 pb-sm-5">
                <b-form-group label="იურიდიული სტატუსი" class="e-nusx-8 e-bold text-muted">
                  <b-select v-model="newRecord.juridicalStatusId" >
                      <option v-for="js in juridicalStatuses" :key="js.$index" :value="js.id">{{js.statusDesc}}</option>
                  </b-select>
                </b-form-group>
                <b-form-row v-if="newRecord.juridicalStatusId === 1">
                <!-- personal info form -->
                <b-form-group label="პირადი ნომერი" class="col-6 e-nusx-8 e-bold text-muted">
                  <b-input v-model="newRecord.personalN" class="e-eng-font"/>
                </b-form-group>
                <b-form-group label="დოკუმენტის ნომერი" class="col-6 e-nusx-8 e-bold text-muted">
                  <b-input v-model="newRecord.documentNumber" class="e-eng-font"/>
                </b-form-group>
                <b-form-group label="სახელი" class="col-6 e-nusx-8 e-bold text-muted">
                  <b-input v-model="newRecord.firstName" class="e-eng-font" />
                </b-form-group>
                <b-form-group label="გვარი" class="col-6 e-nusx-8 e-bold text-muted">
                  <b-input v-model="newRecord.lastName" class="e-eng-font" />
                </b-form-group>
                <b-form-group label="დაბადების თარიღი" class="col-12 e-nusx-8 e-bold text-muted">
                  <datepicker
                    v-model="newRecord.birthDate"
                    :bootstrapStyling="true"
                    :language="locale"
                    :monday-first="true"
                    placeholder="თარიღი არ არის არჩეული"
                    :calendar-button="true"
                    calendar-button-icon="far fa-calendar-alt"
                  />
                  <!-- <b-form-datepicker id="example-bsvue-datepicker-1" v-model="newRecord.birthDate" v-bind="labels.ge" :locale="ka-GE" :start-weekday="weekday" selected-variant="danger"/> -->
                </b-form-group>
                <b-form-group label="მოქალაქეობა" class="col-12 e-nusx-8 e-bold text-muted">
                  <b-input v-model="newRecord.nationality" autocomplete="off" id="countryinput" class="e-eng-font" @input="filterCountries()" @focus="filterCountries(), showPop = true"/>
                  <b-popover id="primaryPopover-container" container="primaryPopover-container" target="countryinput" custom-class="e-popover-danger" placement="bottom" triggers="manual" :show.sync="showPop">
                     <ul class="e-liststyle-none e-eng-font e-listinpopover">
                      <li v-for="cntry in filteredCountriesList" :key="cntry.$index" @click="setCountry(cntry)" class="g-cursor-pointer">{{cntry.countryName}}</li>
                    </ul>
                  </b-popover>
                </b-form-group>
                <b-form-group label="კომენტარი" class="col-12 e-nusx-8 e-bold text-muted">
                  <b-textarea :rows="3" v-model="newRecord.comment"/>
                </b-form-group>
                <!-- / personal info form -->
                </b-form-row>
                <b-form-row v-else-if="newRecord.juridicalStatusId === 2">
                    <b-form-group label="საიდენტიფიკაციო N" class="col-12 e-nusx-8 e-bold text-muted">
                  <b-input v-model="newRecord.personalN" class="e-eng-font"/>
                </b-form-group>
                <b-form-group label="რეგისტრაციის N" class="col-12 e-nusx-8 e-bold text-muted">
                  <b-input v-model="newRecord.documentNumber" class="e-eng-font"/>
                </b-form-group>
                <b-form-group label="დასახელება" class="col-12 e-nusx-8 e-bold text-muted">
                  <b-input v-model="newRecord.firstName" class="e-eng-font" />
                </b-form-group>
                <b-form-group label="რეზიდენტობა" class="col-12 e-nusx-8 e-bold text-muted">
                  <b-input v-model="newRecord.nationality" autocomplete="off" id="countryinput" class="e-eng-font" @input="filterCountries()" @focus="filterCountries(), showPop = true"/>
                  <b-popover id="primaryPopover-container" container="primaryPopover-container" target="countryinput" custom-class="e-popover-danger" placement="bottom" triggers="manual" :show.sync="showPop">
                     <ul class="e-liststyle-none e-eng-font e-listinpopover">
                      <li v-for="cntry in filteredCountriesList" :key="cntry.$index" @click="setCountry(cntry)" class="g-cursor-pointer">{{cntry.countryName}}</li>
                    </ul>
                  </b-popover>
                </b-form-group>
                <b-form-group label="კომენტარი" class="col-12 e-nusx-8 e-bold text-muted">
                  <b-textarea :rows="3" v-model="newRecord.comment"/>
                </b-form-group>
                </b-form-row>
              </div>
            </div>
            </div>
          </b-form>
          <template v-slot:modal-footer>
          <div class="w-100">
            <b-button
              size="sm"
              variant="btn btn-primary"
              @click="save()"
              class="float-right e-mtavr-17"
            >შენახვა</b-button>
            <b-button
              size="sm"
              variant="btn btn-secondary"
              @click="close('addNewWLBLRecord')"
              class="float-right e-mtavr-17 mr-2"
            >გაუქმება</b-button>
          </div>
          </template>
        </b-modal>
    </div>
</template>
<script>
import BaseService from '@/backend/vue-axios/axios.js'
import 'loaders.css/loaders.css'
import 'spinkit/spinkit.css'
import Datepicker from 'vuejs-datepicker'
import { ge } from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
export default {
  components: {
    Datepicker
  },
  data () {
    return {
      currentUser: this.$store.getters.GetCurrentUser,
      locale: ge,
      showPop: false,
      fullCountryList: [],
      filteredCountriesList: [],
      loading: false,
      juridicalStatuses: [],
      newRecord: {
        id: 0,
        firstName: '',
        lastName: '',
        personalN: '',
        documentNumber: '',
        birthDate: 'თარიღი არ არის არჩეული',
        nationality: '',
        addingReasonId: 0,
        addingReason: '',
        additionalInfo: '...',
        recDate: null,
        creatorUserId: 0,
        creatorUserName: '',
        status: true,
        statusChangeDate: null,
        statusChangeUserId: 0,
        statusChangeUserName: '',
        comment: '',
        organisationId: 0,
        juridicalStatusId: 1,
        juridicalStatusDesc: '',
        deleteStatus: false,
        organisationUserId: null
      }
    }
  },
  methods: {
    save () {
      this.loading = true
      this.newRecord.organisationId = this.currentUser.organizationID
      this.newRecord.creatorUserId = this.currentUser.id
      this.newRecord.statusChangeUserId = this.currentUser.id
      this.newRecord.statusChangeUserName = this.currentUser.userName
      this.newRecord.creatorUserName = this.currentUser.userName
      this.newRecord.recDate = moment(Date.now()).format()
      if (this.newRecord.birthDate === 'თარიღი არ არის არჩეული') {
        this.newRecord.birthDate = null
      }
      const header = {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      }
      BaseService.AddWhiteListRecord(header, this.newRecord)
        .then(res => {
          if (res.data.success) {
            this.loading = false
            this.newRecord = {}
            this.$bvModal.hide('addNewWLRecord')
            this.$emit('RecordAdded')
          }
        })

    //   console.log(this.newRecord)
    },
    close (id) {
      this.$bvModal.hide(id)
    },
    filterCountries () {
      // debugger // eslint-disable-line
      if (this.filteredCountriesList.length === 0) {
        this.filteredCountriesList = this.fullCountryList
      }
      this.filteredCountriesList = this.fullCountryList.filter(cntry => {
        this.showPop = true
        return cntry.countryName.toLowerCase().startsWith(this.newRecord.nationality.toLowerCase())
      })
    },
    setCountry (data) {
      this.newRecord.nationality = data.countryName
      this.newRecord.countryId = data.id
      this.showPop = false
    }
  },
  mounted () {
    this.fullCountryList = this.$store.getters.GetCountriesList
    this.juridicalStatuses = this.$store.getters.GetjuridicalStatuses
  }
}
</script>
